(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jco-geo-country-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initGeoPopup = () => {
      const popup = document.getElementById('jco-geo');
      if (!popup || popup.dataset.initialized === 'true') return;
      popup.dataset.initialized = 'true';
      if (window.Shopify && window.Shopify.designMode) return;

      const currentCountry = popup.dataset.currentCountry;
      const selector = popup.querySelector('#jco-geo-country-select');
      const form = popup.querySelector('#JcoGeoLocalizationForm');
      const panel = popup.querySelector('.jco-geo__panel');
      const title = popup.querySelector('#jco-geo-title');
      const countryText = popup.querySelector('#jco-geo-country-name');
      if (!currentCountry || !selector || !form || !panel || !title || !countryText) return;

      const selectionKey = 'jcoGeoSelectionUntil';
      const dismissalKey = 'jcoGeoDismissedUntil';
      const millisecondsPerDay = 86400000;
      let previouslyFocused = null;
      let previousBodyOverflow = '';
      let previousHtmlOverflow = '';

      const getExpiry = (key) => {
        try { return Number(localStorage.getItem(key) || 0); } catch (error) { return 0; }
      };
      const remember = (key, days) => {
        try { localStorage.setItem(key, String(Date.now() + days * millisecondsPerDay)); } catch (error) {}
      };
      const isTextEntry = (element) => Boolean(
        element && element.matches &&
        element.matches('input, textarea, select, [contenteditable], [role="textbox"]')
      );
      const close = () => {
        if (popup.hidden) return;
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        popup.hidden = true;
        document.body.style.overflow = previousBodyOverflow;
        document.documentElement.style.overflow = previousHtmlOverflow;
        remember(dismissalKey, 14);
        if (
          previouslyFocused && previouslyFocused.isConnected &&
          !isTextEntry(previouslyFocused) &&
          typeof previouslyFocused.focus === 'function'
        ) {
          previouslyFocused.focus({ preventScroll: true });
        }
        previouslyFocused = null;
      };
      const open = () => {
        if (isTextEntry(document.activeElement)) return;
        previouslyFocused = document.activeElement;
        previousBodyOverflow = document.body.style.overflow;
        previousHtmlOverflow = document.documentElement.style.overflow;
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        panel.focus({ preventScroll: true });
      };

      popup.querySelectorAll('[data-jco-geo-close]').forEach((element) => {
        element.addEventListener('click', close);
      });

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(popup.querySelectorAll('button, select')).filter((element) => !element.disabled);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      form.addEventListener('submit', (event) => {
        if (selector.value === currentCountry) {
          event.preventDefault();
          close();
          return;
        }
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        remember(selectionKey, 90);
        remember(dismissalKey, 14);
        const returnField = form.querySelector('input[name="return_to"]');
        if (returnField && returnField.value) {
          try {
            const url = new URL(returnField.value, window.location.origin);
            if (url.origin === window.location.origin && url.searchParams.has('country')) {
              url.searchParams.delete('country');
              returnField.value = url.pathname + url.search + url.hash;
            }
          } catch (error) {}
        }
      });

      if (getExpiry(selectionKey) > Date.now() || getExpiry(dismissalKey) > Date.now()) return;

      const root = window.Shopify?.routes?.root || popup.dataset.rootUrl || '/';
      const rootWithSlash = root.endsWith('/') ? root : root + '/';
      const url = new URL(rootWithSlash + 'browsing_context_suggestions.json', window.location.origin);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('country[exclude]', currentCountry);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Suggestions are unavailable');
          return response.json();
        })
        .then((data) => {
          if (!popup.hidden) return;
          const suggested = data?.suggestions?.find((item) => item?.parts?.country?.handle)?.parts?.country;
          const detected = suggested || data?.detected_values?.country;
          const code = detected?.handle;
          if (!code || code === currentCountry) return;
          const option = Array.from(selector.options).find((item) => item.value === code);
          if (!option) return;
          selector.value = code;
          const name = option.dataset.countryName || detected.name || code;
          title.textContent = 'Shopping from ' + name + '?';
          countryText.textContent = name;
          if (getExpiry(selectionKey) > Date.now() || getExpiry(dismissalKey) > Date.now()) return;
          open();
        })
        .catch(() => {});
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGeoPopup, { once: true });
    } else {
      initGeoPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
